<app-case-form-section-container [iconClass]="'bi bi-collection'" [title]="'label.document_library'"
    [navigationLink]="{label: 'label.view_all', link: 'help-document-view-all'}">
    <div class="d-flex justify-content-start mb-3" *ngIf="isAdmin">
        <button class="btn btn-primary default-button" (click)="addNewDocument()">
            <i class="bi bi-plus"></i> {{ 'buttons.upload_new' | translate }}
        </button>
    </div>

 <app-dynamic-table
    *ngIf="isDataTableReady"
    [columns]="columns"
    [rows]="cases"
    [useExternalApi]="true"
    [hidePagination]="true"
    [defaultColumns]="defaultColumns"
    [selectedFilterName]="selectedFilterName"
    (actionButtonEvent)="actionButton($event)"
    (linkedValueClickEvent)="onLinkedValueClick($event)"
    [filters]="filters"
    [dataTableState]="dataTableState"
    [showSaveDatatableFilterBtn]="true"
    [gridSettingsChanged]="!!datatableStateFromStorage"
    (dataTableStateEvent)="onDataTableStateChange($event)"
    (saveDataTableSettingsEvent)="onSaveDatatableSettings($event)"
    (updateDataTableSettingsEvent)="onUpdateDatatableSettings($event)"
    [showColumnsSettingsBtn]="false"
    >
  </app-dynamic-table>
</app-case-form-section-container>


<ng-template #uploadAttachmentsTemplate>
    <app-upload-attachments
      [isRequired]="false"
      [label]="'label.attachments' | translate"
      [readonly]="false"
      (attachmentsChange)="onAttachmentsChange($event)"
      [allowMultiple]="false"
    ></app-upload-attachments>
</ng-template>
